import { useDisclosure } from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { match } from 'ts-pattern';
import { Modal } from 'ui-components';

import { STEP } from './SavedListsModalV2.constants';
import { useSavedListsModalProvider } from './SavedListsModalV2.context';
import { useSavedListStateStore } from './SavedListsModalV2.store';
import { ConfirmationModal } from './components/ConfirmationModal';
import { StepOneSelectLists } from './components/StepOneSelectLists';
import { StepTwoAddNotes } from './components/StepTwoAddNotes';

export const SavedListsModalV2Component: React.FC = () => {
  const { lists: state } = useSavedListStateStore();
  const { step, isOpen, onClose, renderCreateItem } =
    useSavedListsModalProvider();

  const {
    isOpen: isConfirmOpen,
    onOpen: onConfirmOpen,
    onClose: onConfirmClose,
  } = useDisclosure();

  const handleClose = useCallback(() => {
    const listsIds = Object.keys(state);

    if (listsIds.length) {
      return onConfirmOpen();
    }

    return onClose();
  }, [onConfirmOpen, onClose, state]);

  const handleConfirm = useCallback(() => {
    onClose();
    onConfirmClose();
  }, [onClose, onConfirmClose]);

  return (
    <>
      <Modal
        closeOnEsc={renderCreateItem ? false : true}
        closeOnOverlayClick={renderCreateItem ? false : true}
        isOpen={isOpen}
        onClose={handleClose}
        size="md"
      >
        <>
          {match(step)
            .with(STEP.step1, () => <StepOneSelectLists />)
            .with(STEP.step2, () => <StepTwoAddNotes />)
            .otherwise(() => null)}
        </>
      </Modal>

      <ConfirmationModal
        isOpen={isConfirmOpen}
        onClose={onConfirmClose}
        onConfirm={handleConfirm}
      />
    </>
  );
};
